import { useState, useEffect } from "react";
import { Input, Checkbox, Flex } from "antd";
import CustomLabel from "@/components/inputs/CustomLabel";

// const { Search } = Input;
const EMPTY_VALUE = "notFilled";

const FilterString = ({
  value,
  label,
  placeholder = "Поиск",
  onSubmit,
  allowEmpty = false,
}) => {
  const [val, setVal] = useState(value);
  const [isEmpty, setIsEmpty] = useState(value === EMPTY_VALUE);

  useEffect(() => {
    setVal(value === EMPTY_VALUE ? "" : value);
    setIsEmpty(value === EMPTY_VALUE);
  }, [value]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setVal(newValue);
    onSubmit?.(newValue || null);
  };

  const handleEmptyChange = (e) => {
    const checked = e.target.checked;
    setIsEmpty(checked);

    if (checked) {
      onSubmit?.(EMPTY_VALUE);
    } else {
      onSubmit?.(val || null);
    }
  };

  return (
    <div>
      <CustomLabel text={label} />

      <Flex gap={8} align="center">
        <Input
          placeholder={placeholder}
          allowClear
          value={val}
          disabled={isEmpty}
          onChange={handleChange}
          style={{ width: "100%" }}
        />

        {/* <Search
        placeholder={placeholder}
        allowClear
        enterButton={false}
        value={val}
        onChange={(e) => setVal(e.target.value)}
        onSearch={onSubmit}
        style={{ width: "100%" }}
      /> */}

        {allowEmpty && (
          <Checkbox
            style={{ width: 170 }}
            checked={isEmpty}
            onChange={handleEmptyChange}
          >
            Не заполнено
          </Checkbox>
        )}
      </Flex>
    </div>
  );
};

export default FilterString;
